import { FC, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const baseProps: IconProps = {
	width: 20,
	height: 20,
	viewBox: '0 0 24 24',
	fill: 'none',
	stroke: 'currentColor',
	strokeWidth: 2,
	strokeLinecap: 'round',
	strokeLinejoin: 'round',
};

export const BlogIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<polyline points="14 2 14 8 20 8" />
		<line x1="16" y1="13" x2="8" y2="13" />
		<line x1="16" y1="17" x2="8" y2="17" />
		<line x1="10" y1="9" x2="8" y2="9" />
	</svg>
);

export const HeritageIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<line x1="3" y1="22" x2="21" y2="22" />
		<line x1="6" y1="18" x2="6" y2="11" />
		<line x1="10" y1="18" x2="10" y2="11" />
		<line x1="14" y1="18" x2="14" y2="11" />
		<line x1="18" y1="18" x2="18" y2="11" />
		<polygon points="12 2 20 7 4 7" />
	</svg>
);

export const CardIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<rect x="2" y="5" width="20" height="14" rx="2" />
		<line x1="2" y1="10" x2="22" y2="10" />
		<line x1="6" y1="15" x2="10" y2="15" />
	</svg>
);

export const MembershipIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
		<path d="m9 12 2 2 4-4" />
	</svg>
);

export const AuthenticityIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
		<path d="m9 12 2 2 4-4" />
	</svg>
);

export const ConfirmIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<rect x="8" y="2" width="8" height="4" rx="1" />
		<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
		<path d="m9 14 2 2 4-4" />
	</svg>
);

export const UsersIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
		<circle cx="9" cy="7" r="4" />
		<path d="M22 21v-2a4 4 0 0 0-3-3.87" />
		<path d="M16 3.13a4 4 0 0 1 0 7.75" />
	</svg>
);

export const CategoriesIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
		<circle cx="7" cy="7" r="1.2" fill="currentColor" stroke="none" />
	</svg>
);

export const PropertiesIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M3 22V8l9-5 9 5v14" />
		<path d="M3 22h18" />
		<path d="M10 22v-6h4v6" />
		<line x1="8" y1="10" x2="8" y2="10" />
		<line x1="16" y1="10" x2="16" y2="10" />
		<line x1="12" y1="10" x2="12" y2="10" />
		<line x1="8" y1="14" x2="8" y2="14" />
		<line x1="16" y1="14" x2="16" y2="14" />
	</svg>
);

export const LogoutIcon: FC<IconProps> = (props) => (
	<svg {...baseProps} {...props}>
		<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
		<polyline points="16 17 21 12 16 7" />
		<line x1="21" y1="12" x2="9" y2="12" />
	</svg>
);
